<style>
  @import "./invisibe-srci.scss";
</style>
<script>
import { mapGetters } from 'vuex'
import { EventBus } from '../../event-bus'
import {
  CONSTANT
} from '../../utils/constant'
import OtpAuthentication from '../lightbox/otp-authentication/otp-authentication'
import PaymentMethod from '../lightbox/payment-method/payment-method'
import AddCard from '../lightbox/card-enrollment/sub-pages/addcard'
import OtpMethods from '../lightbox/otp-methods/otp-methods'
import Register from '../lightbox/card-enrollment/sub-pages/register'
import Login from '../lightbox/card-enrollment/sub-pages/login'
import GuestCheckout from '../lightbox/card-enrollment/sub-pages/guest-checkout'

export default {
  name: 'InvisibleSrci',

  components: {
    GuestCheckout,
    OtpMethods,
    AddCard,
    PaymentMethod,
    OtpAuthentication,
    Register,
    Login
  },

  data () {
    return {
      cards: [],
      showInlineCards: false,
      noCardFound: false,
      cardLoader: true,
      invisibleCheckout: false,
      constants: CONSTANT,
      showInlineScreen: '',
      currentInlineScreen: CONSTANT.INLINE_SCREEN.REGISTER_SCREEN,
      preCheckoutLoader: true,
      recognizedUser: false
    }
  },

  computed: {
    ...mapGetters([
      'isRecognized',
      'consumerAuthorization',
      'sortedCards',
      'advanced',
      'selectedCheckoutExperience',
      'cartDetails'
    ])
  },

  created () {
    if (this.isRecognized.recognized) {
      this.currentInlineScreen = CONSTANT.INLINE_SCREEN.PAYMENT_SCREEN
    }
  },

  mounted () {
    EventBus.$on('switchConsumer', () => {
      this.currentInlineScreen = CONSTANT.INLINE_SCREEN.LOGIN_SCREEN
    })
    EventBus.$on('switchPage', (event) => {
      this.currentInlineScreen = event
    })
  }
}
</script>
<template>
  <div>
    <div
      v-if="currentInlineScreen === constants.INLINE_SCREEN.LOGIN_SCREEN ||
      currentInlineScreen === constants.INLINE_SCREEN.REGISTER_SCREEN"
      class="text-center"
    >
      <h4 class="page-header font-weight-bold mt-4 mb-4 bottom-margin">
        {{ $t('cardEnrollment.checkoutFaster') }}
        <br class="mt-2">
        {{ $t('cardEnrollment.clickToPay') }}
      </h4>
    </div>
    <div
      :class="currentInlineScreen === constants.INLINE_SCREEN.LOGIN_SCREEN ||
      currentInlineScreen === constants.INLINE_SCREEN.REGISTER_SCREEN ? 'height-c2p':'height27'"
      class="srci-body pt-0 pb-0"
    >
      <div v-if="currentInlineScreen === constants.INLINE_SCREEN.REGISTER_SCREEN">
        <register />
      </div>
      <div v-if="currentInlineScreen === constants.INLINE_SCREEN.LOGIN_SCREEN">
        <login />
      </div>
      <div v-if="currentInlineScreen === constants.INLINE_SCREEN.OTP_SCREEN">
        <otp-authentication />
      </div>
      <div v-if="currentInlineScreen === constants.INLINE_SCREEN.PAYMENT_SCREEN">
        <payment-method />
      </div>
      <div v-if="currentInlineScreen === constants.INLINE_SCREEN.ADD_CARD_SCREEN">
        <addCard />
      </div>
      <div v-if="currentInlineScreen === constants.INLINE_SCREEN.OTP_METHOD_SCREEN">
        <otp-methods />
      </div>
      <div v-if="currentInlineScreen === constants.INLINE_SCREEN.GUEST_CHECKOUT_SCREEN">
        <guest-checkout />
      </div>
    </div>
  </div>
</template>
